<div class="modal-form container">
    <h2 mat-dialog-title class="jumbotron-heading text-center">{{title}}</h2>

    <!--<div class="alert alert-warning">
        isCreateMode: {{isCreateMode}}
    </div>-->
    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">
            <form [formGroup]="companyForm">

                <div class="row">
                    <div class="col-12">
                        <mat-error *ngIf="companyForm.invalid">Fields with * are required</mat-error>
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Company Name</mat-label>
                            <input type="text" matInput formControlName="name" required>
                        </mat-form-field>
                    </div>
                    <!--<div class="col-12">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Company Code</mat-label>
                                <input type="text" matInput formControlName="companyCode" maxlength="16" placeholder="Max of 16 characters">
                            </mat-form-field>
                        </div>-->
                    <div class="col-12" *ngIf="lgvUserSvc.IsAdmin$ | async">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Business Type</mat-label>
                            <mat-select formControlName="businessTypeId"
                                (selectionChange)="selectBusinessType($event.value)" required>
                                <mat-option
                                    *ngFor="let business of lgvApiSvc.businessTypes$ | async | sortBy:'asc':'displayOrder'"
                                    [value]="business.id">
                                    {{business.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12" *ngIf="isRealEstate && !data?.isFromOnboarding">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Lender Partner</mat-label>
                            <mat-select formControlName="lenderPartnerCompanyId"
                                (selectionChange)="selectLenderPartner($event.value)">
                                <mat-option *ngFor="let partner of lgvApiSvc.lenderPartners$ | async"
                                    [value]="partner.id">
                                    {{partner.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12" *ngIf="isRealEstate && data?.isFromOnboarding">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Lender Partner</mat-label>
                            <input type="text" matInput [disabled]="true" formControlName="lenderPartnerCompanyName">
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <lus-address-auto-complete [addressControl]="selectedAddressControl" [showAllFields]="true"
                            [addressIsRequired]="true" [addressInitialValue]="companyInfoParam?.address1"
                            (onAddressChanged)="onAddressChanged($event)" [unitNumberControl]="unitNumberControl"
                            [cityControl]="cityControl" [stateControl]="stateControl"
                            [zipControl]="zipControl"></lus-address-auto-complete>
                        <div class="Vert-10"></div>
                    </div>
                    <div class="col-12" *ngIf="isRealEstate">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Company License</mat-label>
                            <input type="text" matInput formControlName="licenseNumber">
                        </mat-form-field>
                    </div>
                    <div class="col-12" *ngIf="isMortgageCompany">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>NMLSID</mat-label>
                            <input type="text" matInput formControlName="nmlsid">
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Website</mat-label>
                            <input type="text" matInput formControlName="website">
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput formControlName="companyEmail">
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Phone</mat-label>
                            <input type="text" matInput formControlName="phone">
                        </mat-form-field>
                    </div>
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>Fax</mat-label>
                            <input type="text" matInput formControlName="fax">
                        </mat-form-field>
                    </div>

                </div>

                <div class="Vert-10"></div>

                <div class="row">
                    <div class="col-12" align="end">

                        <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                            [disabled]="(isLoading$ | async) || !companyForm.valid">
                            Submit
                        </button>

                        <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                            style="margin-right:10px;">
                            Cancel
                        </button>
                    </div>
                </div>
                <div class="Vert-15"></div>

            </form>
        </div>


    </mat-dialog-content>

</div>
